export default __webpack_public_path__ + "static/media/temporal.2792808f.png";